// extracted by mini-css-extract-plugin
module.exports = {"time":"0.4s","easing":"ease-in-out"};